module.exports = __webpack_public_path__ + "static/media/WorkExperiencePreparationColdCanvassing.4e52f283.pdf";